import React from 'react';
import './styles.css';

const LoadingSpinner = ({ 
  text = 'Loading...', 
  message,
  type = 'default',
  className = ''
}) => {
  // Support both 'text' and 'message' props for backward compatibility
  const displayText = message || text;
  
  const containerClass = type === 'overlay' 
    ? 'loading-overlay' 
    : type === 'card' 
      ? 'card-loading' 
      : type === 'page'
      ? 'page-loading'
      : 'loading-container';

  return (
    <div className={`${containerClass} ${className}`}>
      <div className="loading-spinner-rings">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {displayText && <div className="loading-text">{displayText}</div>}
    </div>
  );
};

export default LoadingSpinner; 